import { cn } from "@gettactic/helpers";
import React from "react";
import { EditorTooltip } from "../../../controls/EditorTooltip";
import { ShortcutString } from "../../../shortcuts/shortcuts";

export interface ShapeControlButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "title"> {
  title: React.ReactNode;
  shortcut?: ShortcutString;
  icon?: React.FC<{ size?: number | string }>;
  /** Style hover state with the destructive token (e.g. delete). */
  isDestructive?: boolean;
}

export const ShapeControlButton = React.forwardRef<
  HTMLButtonElement,
  ShapeControlButtonProps
>(
  (
    { children, title, shortcut, className, icon, isDestructive, ...rest },
    ref
  ) => {
    return (
      <EditorTooltip message={title} shortcut={shortcut} asChild>
        <button
          ref={ref}
          type="button"
          aria-label={typeof title === "string" ? title : undefined}
          {...rest}
          className={cn(
            "flex h-7 min-w-7 flex-none items-center justify-center gap-1 rounded-md px-1 text-neutral-600 transition-colors",
            isDestructive
              ? "hover:bg-red-50 hover:text-red-600"
              : "hover:bg-neutral-100 hover:text-neutral-900",
            className
          )}
        >
          {icon ? React.createElement(icon, { size: 15 }) : undefined}
          {children}
        </button>
      </EditorTooltip>
    );
  }
);
ShapeControlButton.displayName = "ShapeControlButton";
